
const stats = [
  {
    icon: 'ri-user-star-line',
    number: '500+',
    label: 'Başarılı Öğrenci',
    description: 'Almanya\'da eğitim alan',
  },
  {
    icon: 'ri-building-line',
    number: '50+',
    label: 'Partner Üniversite',
    description: 'İşbirliği yaptığımız',
  },
  {
    icon: 'ri-checkbox-circle-line',
    number: '%98',
    label: 'Vize Başarı Oranı',
    description: 'Yüksek başarı ile',
  },
  {
    icon: 'ri-time-line',
    number: '10+',
    label: 'Yıllık Deneyim',
    description: 'Almanya\'da',
  },
];

export default function Stats() {
  return (
    <>
      <section className="py-24 bg-[#1a1a1a] relative overflow-hidden">
        {/* Background Pattern */}
        <div className="absolute inset-0 opacity-20">
          <div className="absolute top-0 left-0 w-96 h-96 bg-[#DD0000] rounded-full blur-[150px]"></div>
          <div className="absolute bottom-0 right-0 w-96 h-96 bg-[#FFCE00] rounded-full blur-[150px]"></div>
        </div>

        <div className="container mx-auto px-4 relative z-10">
          {/* Section Header */}
          <div className="text-center mb-16">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-[#FFCE00]/20 rounded-full mb-4">
              <i className="ri-bar-chart-line text-[#FFCE00]"></i>
              <span className="text-white text-sm font-medium">Rakamlarla Rota Berlin</span>
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
              Başarılarımız
            </h2>
            <p className="text-lg text-white/80 max-w-2xl mx-auto">
              Yıllardır öğrencilerimize sunduğumuz kaliteli hizmetin sonuçları
            </p>
          </div>

          {/* Stats Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {stats.map((stat, index) => (
              <div
                key={index}
                className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-2xl p-8 text-center hover:bg-white/20 transition-all group cursor-pointer"
              >
                <div className="w-16 h-16 mx-auto mb-6 rounded-xl bg-[#DD0000]/20 flex items-center justify-center group-hover:scale-110 transition-transform">
                  <i className={`${stat.icon} text-3xl text-[#FFCE00]`}></i>
                </div>
                <div className="text-5xl font-bold text-[#FFCE00] mb-2">{stat.number}</div>
                <div className="text-xl font-semibold text-white mb-1">{stat.label}</div>
                <div className="text-sm text-white/70">{stat.description}</div>
              </div>
            ))}
          </div>

          {/* CTA */}
          <div className="mt-16 text-center">
            <a
              href="#randevu"
              className="inline-flex items-center gap-2 px-8 py-4 bg-[#DD0000] text-white text-lg font-semibold rounded-lg hover:bg-[#bb0000] hover:shadow-2xl hover:scale-105 transition-all whitespace-nowrap cursor-pointer"
            >
              <span>Siz de Aramıza Katılın</span>
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </div>
      </section>

      {/* Profesyonel Danışmanlarımız */}
      <section className="py-24 bg-white">
        <div className="container mx-auto px-4">
          <div className="flex justify-center">
            <div className="bg-gray-50 rounded-2xl p-8 text-center max-w-sm hover:shadow-xl transition-all group">
              <div className="w-48 h-48 mx-auto mb-6 rounded-full overflow-hidden border-4 border-[#FFCE00] group-hover:border-[#DD0000] transition-colors">
                <img
                  src="https://static.readdy.ai/image/e51399e73e35a4762b4f070880195b49/f17e173b419b59185525ecf29975c219.jpeg"
                  alt="Yönetici"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="inline-flex items-center gap-2 px-3 py-1 bg-[#DD0000] text-white text-xs font-semibold rounded-full mb-3">
                <i className="ri-vip-crown-line"></i>
                <span>Yönetici</span>
              </div>
              <h3 className="text-xl font-bold text-[#1a1a1a] mb-2">Sebahat</h3>
              <p className="text-[#DD0000] font-semibold mb-3">Eğitim Danışmanı</p>
              <p className="text-gray-600 text-sm mb-4">
                Almanya'da eğitim süreçleri konusunda uzman danışmanımız, öğrencilerimize profesyonel rehberlik sağlamaktadır.
              </p>
              <div className="flex justify-center gap-3">
                <button
                  type="button"
                  disabled
                  className="flex items-center gap-2 px-4 py-2 bg-[#25D366]/50 rounded-full text-white cursor-default"
                >
                  <i className="ri-whatsapp-line text-lg"></i>
                  <span className="text-sm font-medium">WhatsApp</span>
                </button>
                <a
                  href="mailto:rotaberlinn@gmail.com"
                  className="flex items-center gap-2 px-4 py-2 bg-[#1a1a1a] rounded-full text-white hover:scale-105 transition-transform cursor-pointer"
                >
                  <i className="ri-mail-line text-lg"></i>
                  <span className="text-sm font-medium">E-posta</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
